import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Observable } from 'rxjs-compat';
import { BaseController } from '../../base.controller';
import { SecurityController } from '../../security/security.controller';
import { RoutePropertyDto } from './RoutePropertyDto';
import { RoutePropertyLogDto } from './RoutePropertyLogDto';
import { RoutePropertyChanged } from './RoutePropertyChanged';


@Injectable({
    providedIn: 'root'
})
export class RoutePropertyController extends BaseController {
    private base = '/routeproperty';

    constructor(
        @Inject('SecurityController') protected securityController: SecurityController,
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router
    ) {
        super(http, alertService, translateService, loadingService, router);
    }

    getPropertiesByRouteId(routeId: number): Observable<Array<RoutePropertyDto>> {
        return this.get(this.base + '/routeId/' + routeId);
    }

    getPropertiesLinkedToSlotsByRouteId(routeId: number): Observable<Array<RoutePropertyDto>> {
        return this.get(this.base + '/routeId/' + routeId + "/linkedtoslots");
    }

    existsPropertiesLinkedToSlotsByRouteId(routeId: number): Observable<boolean> {
        return this.get(this.base + '/routeId/' + routeId + "/linkedtoslots/exists");
    }

    getPropertiesLinkedToSlotsPendingResponseByRouteId(routeId: number): Observable<Array<RoutePropertyDto>> {
        return this.get(this.base + '/routeId/' + routeId + "/linkedtoslots/pendingresponse");
    }

    existsPropertiesLinkedToSlotsPendingResponseByRouteId(routeId: number): Observable<boolean> {
        return this.get(this.base + '/routeId/' + routeId + "/linkedtoslots/pendingresponse/exists");
    }

    getRoutePropertyLogsByRoutePropertyId(routePropertyId: number): Observable<Array<RoutePropertyLogDto>> {
        return this.get(this.base + '/routePropertyId/' + routePropertyId + '/logs');
    }

    setValue(rpDTO: RoutePropertyDto): Observable<RoutePropertyChanged> {
        return this.post(this.base + '/setvalue/', rpDTO, "setValue");
    }

    setValueList(rpDTOs: RoutePropertyDto[]): Observable<RoutePropertyChanged> {
        return this.post(this.base + '/setvaluelist/', rpDTOs, "setValueList");
    }
    setValueListPhaseId(rpDTOs: RoutePropertyDto[], phaseId: number): Observable<RoutePropertyChanged> {
        return this.post(this.base + '/setvaluelist/phaseId/' + phaseId, rpDTOs, "setValueList");
    }

    compute(routeId: number): Observable<boolean> {
        return this.getBusy(this.base + '/routeId/' + routeId + '/compute');
    }
    reset(routeId: number): Observable<boolean> {
        return this.putBusy(this.base + '/routeId/' + routeId + '/reset', null, "reset");
    }

}